import Charts from '../../scaffold/src/components/Charts';
import CountDown from '../../scaffold/src/components/CountDown';
import DescriptionList from '../../scaffold/src/components/DescriptionList';
import Exception from '../../scaffold/src/components/Exception';
import FooterToolbar from '../../scaffold/src/components/FooterToolbar';
import GlobalFooter from '../../scaffold/src/components/GlobalFooter';
import HeaderSearch from '../../scaffold/src/components/HeaderSearch';
import NoticeIcon from '../../scaffold/src/components/NoticeIcon';
import PageHeader from '../../scaffold/src/components/PageHeader';
import Result from '../../scaffold/src/components/Result';
import TagSelect from '../../scaffold/src/components/TagSelect';
import AvatarList from '../../scaffold/src/components/AvatarList';

export default {
  Charts,
  CountDown,
  DescriptionList,
  Exception,
  FooterToolbar,
  GlobalFooter,
  HeaderSearch,
  NoticeIcon,
  PageHeader,
  Result,
  TagSelect,
  AvatarList,
};



// WEBPACK FOOTER //
// ./index.js